__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.5.2-fdc6895-10148/_next/";